import {
  fetchConditionForecast,
  fetchWaveForecast,
  fetchTideForecast,
  fetchWeatherForecast,
  fetchWindForecast,
  fetchRegionalConditionForecast,
  fetchRegionalWaveForecast,
} from '../common/api/kbyg';

const baseFetchGraphForecast = (action, success, failure, fetch) => (id, days, intervalHours) =>
  async (dispatch) => {
    dispatch({ type: action });
    try {
      const response = await fetch(id, days, intervalHours);
      dispatch({
        type: success,
        intervalHours,
        response,
      });
    } catch (error) {
      dispatch({
        type: failure,
        error,
      });
    }
  };

export const FETCH_GRAPH_CONDITION_FORECAST = 'FETCH_GRAPH_CONDITION_FORECAST';
export const FETCH_GRAPH_CONDITION_FORECAST_SUCCESS = 'FETCH_GRAPH_CONDITION_FORECAST_SUCCESS';
export const FETCH_GRAPH_CONDITION_FORECAST_FAILURE = 'FETCH_GRAPH_CONDITION_FORECAST_FAILURE';

export const fetchGraphConditionForecast = type => baseFetchGraphForecast(
  FETCH_GRAPH_CONDITION_FORECAST,
  FETCH_GRAPH_CONDITION_FORECAST_SUCCESS,
  FETCH_GRAPH_CONDITION_FORECAST_FAILURE,
  type === 'REGIONAL' ? fetchRegionalConditionForecast : fetchConditionForecast,
);

export const FETCH_GRAPH_WAVE_FORECAST = 'FETCH_GRAPH_WAVE_FORECAST';
export const FETCH_GRAPH_WAVE_FORECAST_SUCCESS = 'FETCH_GRAPH_WAVE_FORECAST_SUCCESS';
export const FETCH_GRAPH_WAVE_FORECAST_FAILURE = 'FETCH_GRAPH_WAVE_FORECAST_FAILURE';

export const fetchGraphWaveForecast = type => baseFetchGraphForecast(
  FETCH_GRAPH_WAVE_FORECAST,
  FETCH_GRAPH_WAVE_FORECAST_SUCCESS,
  FETCH_GRAPH_WAVE_FORECAST_FAILURE,
  type === 'REGIONAL' ? fetchRegionalWaveForecast : fetchWaveForecast,
);

export const FETCH_GRAPH_TIDE_FORECAST = 'FETCH_GRAPH_TIDE_FORECAST';
export const FETCH_GRAPH_TIDE_FORECAST_SUCCESS = 'FETCH_GRAPH_TIDE_FORECAST_SUCCESS';
export const FETCH_GRAPH_TIDE_FORECAST_FAILURE = 'FETCH_GRAPH_TIDE_FORECAST_FAILURE';

export const fetchGraphTideForecast = baseFetchGraphForecast(
  FETCH_GRAPH_TIDE_FORECAST,
  FETCH_GRAPH_TIDE_FORECAST_SUCCESS,
  FETCH_GRAPH_TIDE_FORECAST_FAILURE,
  fetchTideForecast,
);

export const FETCH_GRAPH_WEATHER_FORECAST = 'FETCH_GRAPH_WEATHER_FORECAST';
export const FETCH_GRAPH_WEATHER_FORECAST_SUCCESS = 'FETCH_GRAPH_WEATHER_FORECAST_SUCCESS';
export const FETCH_GRAPH_WEATHER_FORECAST_FAILURE = 'FETCH_GRAPH_WEATHER_FORECAST_FAILURE';

export const fetchGraphWeatherForecast = baseFetchGraphForecast(
  FETCH_GRAPH_WEATHER_FORECAST,
  FETCH_GRAPH_WEATHER_FORECAST_SUCCESS,
  FETCH_GRAPH_WEATHER_FORECAST_FAILURE,
  fetchWeatherForecast,
);

export const FETCH_GRAPH_WIND_FORECAST = 'FETCH_GRAPH_WIND_FORECAST';
export const FETCH_GRAPH_WIND_FORECAST_SUCCESS = 'FETCH_GRAPH_WIND_FORECAST_SUCCESS';
export const FETCH_GRAPH_WIND_FORECAST_FAILURE = 'FETCH_GRAPH_WIND_FORECAST_FAILURE';

export const fetchGraphWindForecast = baseFetchGraphForecast(
  FETCH_GRAPH_WIND_FORECAST,
  FETCH_GRAPH_WIND_FORECAST_SUCCESS,
  FETCH_GRAPH_WIND_FORECAST_FAILURE,
  fetchWindForecast,
);



// WEBPACK FOOTER //
// ./src/actions/graphs.js